import React, { useEffect } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import styles from '../assets/css/Layout.module.css';
import logo from '../assets/images/marca Zafiro Farmacia - bitmap-positivo-fullcolor.jpg';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { isAuthenticated, getUserType, getSession, logout } from '../utils/session';

function Layout() {
  const location = useLocation();
  const navigate = useNavigate();

  const logueado = isAuthenticated();
  const tipoUsuario = getUserType();

  useEffect(() => {
    const session = getSession();

    if (!session && localStorage.getItem('session')) {
      toast.dismiss();
      toast.warn('Tu sesión ha expirado. Hacé clic para renovarla.', {
        position: 'top-center',
        autoClose: false,
        closeOnClick: true,
        onClick: () => {
          navigate('/login', { state: { fromSessionExpiry: true } });
        },
        closeButton: true,
      });
    }
  }, [navigate]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className={styles.layout}>
      <header className={styles.navbar}>
        <Link to="/" className={styles.logoLink}>
          <img src={logo} alt="Zafiro Validaciones" className={styles.logo} />
        </Link>

        <div className={styles.navRight}>
          {logueado && (
            <>
              <Link to="/dashboard" className={styles.loginBtn}>
                Dashboard
              </Link>

              {tipoUsuario === 'coseguro' && (
                <a
                  href="https://zafirovalidadores.com.ar/portal-coseguros"
                  className={styles.loginBtn}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Monitor
                </a>
              )}

              <button onClick={handleLogout} className={styles.loginBtn}>
                Cerrar sesión
              </button>
            </>
          )}

          {!logueado && location.pathname !== '/login' && (
            <Link to="/login" className={styles.loginBtn}>
              Iniciar sesión
            </Link>
          )}
        </div>
      </header>

      <main className={styles.main}>
        <Outlet />
      </main>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <footer className={styles.footer}>
        © {new Date().getFullYear()} Zafiro Validadores. Todos los derechos reservados.
      </footer>
    </div>
  );
}

export default Layout;
